import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SIDEBARNAVIGATIONMODAL_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "cgv_url",
  "privacy_policy_url",
  "legal_notice_url",
  "display_home_link",
  "display_see_all_distribution_modes",
  { type: 'separator', allowedRoles: ['ADMIN'] },
  "display_powered_by_dood",
  "footer_message",
  "footer_message_url"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  sidebarNavigationModalDescriptor: _generatedSidebarNavigationModalDescriptor,
  sidebarNavigationModalModalDefinition,
  sidebarNavigationModalDashboardLayout,
  sidebarNavigationModalConfig,
  sidebarNavigationModalResolveConfig,
  sidebarNavigationModalProperties,
} = doodModalConfig(
  {
    name: "Sidebar navigation",
    handle: "sidebar-navigation-modal",
    internal_name: "SidebarNavigationModal",
    componentType: 'SidebarNavigationModalComponent',
    category: 'modal',
    description: "Sidebar navigation.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "sidebar-navigation-modal",
    sharedFields: {}
,
    slots: [
      {
        key: 'custom_items',
        name: "editBlock.sidebarNavigationModal.customItems",
        accept: 'explicitOnly',
        allowedTypes: ["SidebarNavigationModalItemBlock", "SidebarNavigationModalPrepaymentAccountItemBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    cgv_url: propertyValue({
      type: 'text',
      value: "https://www.dood.com/corporate/cgv/",
      options: {
        "label": "editBlock.sidebarNavigationModal.cgvUrl",
        "placeholder": "https://",
        "value": "https://www.dood.com/corporate/cgv/"
      }
    }),
    privacy_policy_url: propertyValue({
      type: 'text',
      value: "https://www.dood.com/corporate/politique-de-confidentialite/",
      options: {
        "label": "editBlock.sidebarNavigationModal.privacyPolicyUrl",
        "placeholder": "https://",
        "value": "https://www.dood.com/corporate/politique-de-confidentialite/"
      }
    }),
    legal_notice_url: propertyValue({
      type: 'text',
      value: "https://www.dood.com/corporate/mentions-legales/",
      options: {
        "label": "editBlock.sidebarNavigationModal.legalNoticeUrl",
        "placeholder": "https://",
        "value": "https://www.dood.com/corporate/mentions-legales/"
      }
    }),
    display_home_link: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        "label": "editBlock.sidebarNavigationModal.displayHomeLink"
      }
    }),
    display_see_all_distribution_modes: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: 'editBlock.sidebarNavigationModal.displaySeeAllDistributionModes',
      },
    }),
    display_powered_by_dood: propertyValue({
      type: 'checkbox',
      value: true,
      allowedRoles: ['ADMIN'],
      options: {
        "label": "editBlock.sidebarNavigationModal.displayPoweredByDood"
      }
    }),
    footer_message: propertyValue({
      type: 'text',
      value: '',
      allowedRoles: ['ADMIN'],
      options: {
        "label": "editBlock.sidebarNavigationModal.footerMessage"
      }
    }),
    footer_message_url: propertyValue({
      type: 'text',
      value: '',
      allowedRoles: ['ADMIN'],
      options: {
        "label": "editBlock.sidebarNavigationModal.footerMessageUrl",
        "placeholder": "https://"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["custom_items", "cgv_url", "privacy_policy_url", "legal_notice_url", "display_home_link", "display_see_all_distribution_modes", "display_powered_by_dood", "footer_message", "footer_message_url"],
          },
        ],
      },
    ],
  })
);

export function sidebarNavigationModalDescriptor(): IBlockDescriptor;
export function sidebarNavigationModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function sidebarNavigationModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSidebarNavigationModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSidebarNavigationModalDescriptor, sidebarNavigationModalProperties, fieldOrder);
}

export {
  sidebarNavigationModalModalDefinition,
  sidebarNavigationModalDashboardLayout,
  sidebarNavigationModalProperties,
  sidebarNavigationModalConfig,
  sidebarNavigationModalResolveConfig,
};

export type SidebarNavigationModalConfig = typeof sidebarNavigationModalConfig;
